<nz-spin [nzSpinning]="isSpinning">
  <div *ngIf="STATUS_CODE==200">
    <div nz-row [nzGutter]="16">

      <div nz-col nzSpan="6" >
        <div class="my-box" style="background: linear-gradient(30deg, #0467cd, #1bd5ff)!important;">
  
          <h4>Total Dairy Outlet </h4>
          <h3 style="font-size: 18px;"><i nz-icon nzType="bar-chart" nzTheme="outline"></i> {{DAIRY_COUNT}}</h3>
          <h4>{{JOINED_TO_DAIRY_COUNT}} Farmers
          </h4> 
        </div>
      </div>
      <div nz-col nzSpan="6" >
        <div class="my-box" style="background: linear-gradient(30deg, #cf097f, #845cff)!important;">
          <h4>Total One Mans</h4>
          <h3 style="font-size: 18px;"><i nz-icon nzType="bar-chart" nzTheme="outline"></i> {{ONEMAN_COUNT}}
          </h3>
          <h4>{{JOINED_TO_ONEMAN_COUNT}} Farmers
          </h4>
        </div>
      </div>
      <div nz-col nzSpan="6" >
        <div class="my-box" style="background: linear-gradient(30deg, #6a11cb , #2575fc)!important;">
          <h4>Total Chilling Centers </h4>
          <h3 style="font-size: 18px;"><i nz-icon nzType="bar-chart" nzTheme="outline"></i> {{CHILLING_COUNT}}</h3>
          <h4>{{JOINED_TO_CHILLING_COUNT}} Farmers
          </h4>
        </div>
      </div>
      <div nz-col nzSpan="6" >
        <div class="my-box" style="background: linear-gradient(30deg, #b20465, #ffbd5a)!important;">
          <h4>Total Gavalis</h4>
          <h3 style="font-size: 18px;"><i nz-icon nzType="bar-chart" nzTheme="outline"></i> {{GAVALI_COUNT}}</h3>
          <h4>{{JOINED_TO_GAVALI_COUNT}} Farmers
          </h4>
        </div>
      </div>
      
          <!-- <div nz-col nzSpan="4" > -->
        <!-- <div class="my-box" style="background: linear-gradient(30deg, #02b59c, #ffc121)!important;">
  
          <h3 style="font-size: 18px;"><i nz-icon nzType="bar-chart" nzTheme="outline"></i> {{BANK_SIDE_PENDING_COUNT}}
          </h3>
          <h4>Live Videos</h4>
        </div>
      </div>
      <div nz-col nzSpan="4" >
        <div class="my-box" style="background: linear-gradient(30deg, #04707b, #1bffdf)!important;">
  
          <h3 style="font-size: 18px;"><i nz-icon nzType="bar-chart" nzTheme="outline"></i>
            {{CUSTOMER_SIDE_PENDING_COUNT}}
          </h3>
          <h4>Total Courses</h4>
        </div>
      </div> -->
    </div>
  
    <div nz-row>
      <div nz-col nzSpan="24" class="my-box2">
        <div nz-row>
          <div nz-col nzSpan="24">
            <div class="formname"> Farmers Joined <nz-date-picker style="margin-left: 10px;" nzFormat="MMM-yyyy" nzMode="month"
                [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
            </div>
            <br>
          </div>
          <div nz-col nzSpan="24" id="chart">
            <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
              [stroke]="chartOptions.stroke" [colors]="chartOptions.colors" [dataLabels]="chartOptions.dataLabels"
              [legend]="chartOptions.legend" [markers]="chartOptions.markers" [grid]="chartOptions.grid"
              [yaxis]="chartOptions.yaxis" [title]="chartOptions.title"></apx-chart>
          </div>
        </div>
  
      </div>
  
      <div nz-col nzSpan="11" class="my-box2">
        <div nz-row>
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="10">
            <div class="formname"> Live Videos Status </div>
          </div>
          <!-- <div nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-label nzNoColon> Type </nz-form-label>
              <nz-form-control>
                <nz-switch name="status" (click)="changePieChart()" nzCheckedChildren="Count" nzUnCheckedChildren="Amount"
                  [(ngModel)]="TYPE">
                </nz-switch>
              </nz-form-control>
            </nz-form-item>
          </div> -->
          <div nz-col nzXs="24">
            <apx-chart style="position: relative; top:25px" [series]="chartOptions3.series" [chart]="chartOptions3.chart" [labels]="chartOptions3.labels"
              [responsive]="chartOptions3.responsive"></apx-chart>
          </div>
        </div>
  
      </div>
      <div nz-col nzSpan="12" nzOffset="1" class="my-box2">
        <div nz-row nzType="flex">
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="10">
            <div class="formname"> Pincode Wise </div>
          </div>
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="14" style="display: flex;justify-content: flex-end">
            <!-- <form nz-form [nzLayout]="'inline'">
      
      
                  <nz-form-item>
                    <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton1">
                      <input type="text" name="search" nz-input placeholder="Search Branch" [(ngModel)]="branchsearchText"
                        (keydown.enter)="branchsearchSet()" />
                    </nz-input-group>
                    <ng-template #suffixIconButton1>
                      <button nz-button nzType="primary" (click)="setBranchCount(true)" name="branchbutton" id="branchbutton" nzSearch><i
                          nz-icon nzType="search"></i></button>
                    </ng-template>
                  </nz-form-item>
                </form> -->
          </div>
        </div>
  
        <div nz-row>
          <div nz-col nzSpan="24">
            <nz-table class="my-scroll no-wrap1" nzBordered #tables nzShowSizeChanger 
              [nzData]="pincodeWiseData" [nzTotal]="totalRecords" [(nzPageIndex)]="pageIndex"
              [(nzPageSize)]="pageSize">
              <thead>
                <tr>
                  <th *ngFor="let column of listOfColumn" [nzSortFn]="column.compare">{{ column.title }} </th>
                 
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of tables.data;index as i">
  
                  <td style="white-space: pre;">
                    {{data.PINCODE}}
                  </td>
                  <td>
                    {{data.COUNT}}
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
    </div>
  
    
    <div nz-row style="padding-bottom: 30px;">
      <div nz-col nzSpan="24" class="my-box2">
  
        <div nz-row nzType="flex">
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="10">
            <div class="formname"> Course Wise </div>
          </div>
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="14" style="display: flex;justify-content: flex-end">
            <!-- <form nz-form [nzLayout]="'inline'">
      
      
                <nz-form-item>
                  <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" nz-input placeholder="Search Here" [(ngModel)]="searchText2"
                      (keydown.enter)="searchSet2()" />
                  </nz-input-group>
                  <ng-template #suffixIconButton>
                    <button nz-button nzType="primary" (click)="search2(true)" name="button2" id="button2" nzSearch><i nz-icon
                        nzType="search"></i></button>
                  </ng-template>
                </nz-form-item>
              </form> -->
            
          </div>
        </div>
        <br>
        <div nz-row>
          <div nz-col nzSpan="24">
            <nz-table class="my-scroll no-wrap1" [nzShowPagination]="false" nzBordered #table3 nzShowSizeChanger 
              [nzData]="courseWiseCount" >
              <thead >
                <tr>
                  <th *ngFor="let column of listOfColumn1" [nzSortFn]="column.compare">{{ column.title }} </th>
                 
                  <!-- <th *ngFor="let column of columns2" >{{column[1]}}</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of table3.data;index as i">
                  <td *ngFor="let column of columns2">{{data[column[0]]}}</td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
  
      </div>
      <div nz-col nzSpan="24" class="my-box2">
  

        <div nz-row nzType="flex">
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="10">
            <div class="formname">Live Video Wise</div>
          </div>
          <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="14" style="display: flex;justify-content: flex-end">
            <!-- <form nz-form [nzLayout]="'inline'">
      
      
                <nz-form-item>
                  <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" nz-input placeholder="Search Here" [(ngModel)]="searchText2"
                      (keydown.enter)="searchSet2()" />
                  </nz-input-group>
                  <ng-template #suffixIconButton>
                    <button nz-button nzType="primary" (click)="search2(true)" name="button2" id="button2" nzSearch><i nz-icon
                        nzType="search"></i></button>
                  </ng-template>
                </nz-form-item>
              </form> -->
            
          </div>
        </div>
        <br>
        <div nz-row>
          <div nz-col nzSpan="24">
            <nz-table class="my-scroll no-wrap1" nzBordered #table2 nzShowSizeChanger  
              [nzData]="liveVideoCount" >
              <thead >
                <tr>
                  <th *ngFor="let column of listOfColumn2"  [nzSortFn]="column.compare">{{ column.title }} </th>

                  <!-- <th *ngFor="let column of columns" >{{column[1]}}</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of table2.data;index as i">
                  <td >{{data.NAME}}</td>
                  <td >{{data.WATCHED_COUNT}}</td>
                  <td >{{getTime(data.WATCHING_TIME)}}</td>
                  <td >{{data.LIKE_COUNT}}</td>
                  <td >{{data.TOTAL_COMMENTS}}</td>
                  </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
    </div>
  </div>
 
</nz-spin>